import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appScrollToReqContainer]',
})
export class ScrollToRequiredContainerDirective {
  private el: ElementRef = inject(ElementRef);

  // defines the scroll container for [appScrollToReq]

  readonly containerEl: HTMLElement = this.el.nativeElement;
}
